import React from 'react';
import { MessageCircle, Calendar, FileText, Info, ChevronRight, CheckCircle } from 'lucide-react';
import { isVenueClaimed } from './venueHelpers';

const VenueQuickContact = React.memo(({ venue, smartPricingEnabled, onWhatsAppAction }) => {
  if (smartPricingEnabled) return null;

  return (
    <div className="relative">
      <div className={`bg-gradient-to-br from-white to-green-50 rounded-2xl shadow-lg transition-all duration-300 border border-green-100 overflow-hidden ${!isVenueClaimed(venue) ? 'opacity-40' : 'hover:shadow-xl'}`}>
        {/* Header */}
        <div className={`px-5 py-4 ${isVenueClaimed(venue) ? 'bg-gradient-to-r from-green-500 to-emerald-600' : 'bg-gradient-to-r from-gray-400 to-gray-500'}`}>
          <div className="flex items-center gap-3">
            <div className="bg-white/20 p-2 rounded-xl">
              <MessageCircle className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-bold text-white text-base">Hızlı İletişim</h3>
              <p className={`text-xs ${isVenueClaimed(venue) ? 'text-green-100' : 'text-gray-200'}`}>WhatsApp ile anında ulaşın</p>
            </div>
          </div>
        </div>
        
        <div className="p-5">
          {isVenueClaimed(venue) && (
            <p className="text-gray-600 text-sm mb-4">
              Tıkladığınızda WhatsApp üzerinden {venue.name} yetkilisine yönlendirilirsiniz.
            </p>
          )}
          
          <div className="space-y-2">
            {[
              { type: 'quick_quote', icon: FileText, color: 'pink', title: 'Teklif Al', desc: 'Fiyat ve paket bilgisi alın' },
              { type: 'availability', icon: Calendar, color: 'blue', title: 'Müsaitlik Öğren', desc: 'Tarih uygunluğunu sorun' },
              { type: 'info', icon: Info, color: 'amber', title: 'Bilgi Al', desc: 'Mekan hakkında soru sorun' },
            ].map(({ type, icon: Icon, color, title, desc }) => (
              <button
                key={type}
                onClick={() => isVenueClaimed(venue) && onWhatsAppAction(type)}
                disabled={!isVenueClaimed(venue)}
                className={`flex items-center gap-3 w-full p-3 border rounded-xl transition-all duration-200 ${
                  isVenueClaimed(venue) 
                    ? 'bg-white hover:bg-green-50 border-gray-200 hover:border-green-300 cursor-pointer group' 
                    : 'bg-gray-50 border-gray-200 cursor-not-allowed'
                }`}
                data-testid={`${type}-btn`}
              >
                <div className={`p-2 rounded-lg ${isVenueClaimed(venue) ? `bg-${color}-100 group-hover:bg-${color}-200` : 'bg-gray-200'}`}>
                  <Icon className={`w-4 h-4 ${isVenueClaimed(venue) ? `text-${color}-600` : 'text-gray-400'}`} />
                </div>
                <div className="flex-1 text-left">
                  <p className={`font-semibold text-sm ${isVenueClaimed(venue) ? 'text-gray-900' : 'text-gray-400'}`}>{title}</p>
                  <p className={`text-xs ${isVenueClaimed(venue) ? 'text-gray-500' : 'text-gray-400'}`}>{desc}</p>
                </div>
                <ChevronRight className={`w-4 h-4 ${isVenueClaimed(venue) ? 'text-gray-400 group-hover:text-green-500 group-hover:translate-x-1' : 'text-gray-300'} transition-all`} />
              </button>
            ))}
          </div>
          
          {isVenueClaimed(venue) && (
            <div className="mt-4 pt-3 border-t border-gray-100">
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <CheckCircle className="w-3.5 h-3.5 text-green-500" />
                <span>Genellikle birkaç dakika içinde yanıt alırsınız</span>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {!isVenueClaimed(venue) && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/60 rounded-2xl">
          <div className="bg-amber-100 border border-amber-300 rounded-xl px-4 py-3 shadow-lg">
            <p className="text-amber-800 text-sm font-medium text-center">
              Bu özellik, yalnızca doğrulanmış<br/>mekânlarda aktiftir.
            </p>
          </div>
        </div>
      )}
    </div>
  );
});

VenueQuickContact.displayName = 'VenueQuickContact';
export default VenueQuickContact;
